<template>
    <div class="paperpile_section_wrp">
        <div class="paperpile_content_wrp">
            <div class="paperpile_content_header">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="rfiles_main_heading"><button type="button" class="btn back_btn" tapable
                                @click="$router.go(-1)">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>Add Paper</h2>
                    </div>
                </div>
            </div>
            <div class="create_paperpile_popup">
                <div class="create_paperpile_popup_center">
                    <div class="create_paperpile_popup_modal">
                        <!-- <div class="create_paperpile_popup_header">
                            <h4>Paper</h4>
                            <span class="create_paperpile_popup_close" @click="closeCreatePaperpilePopup">
                                <i class="fa fa-times-circle" aria-hidden="true"></i>
                            </span>
                        </div> -->

                        <div class="create_paperpile_popup_body">
                            <div class="paper_tabs">
                                <div class="tab_item" :class="{ active: paper_upload_state === 'local' }"
                                    @click="paper_upload_state = 'local'">
                                    <i class="fa fa-cloud-upload"></i>
                                    <span>Upload Paper</span>
                                </div>
                                <div class="tab_item" :class="{ active: paper_upload_state === 'query' }"
                                    @click="paper_upload_state = 'query'">
                                    <i class="fa fa-search"></i>
                                    <span>Find Papers</span>
                                </div>
                                <div class="tab_item" :class="{ active: paper_upload_state === 'dio' }"
                                    @click="paper_upload_state = 'dio'">
                                    <i class="fa fa-link"></i>
                                    <span>Paper DOI</span>
                                </div>
                            </div>

                            <div class="tab_content">
                                <upload-paper-f-local v-if="paper_upload_state == 'local'"></upload-paper-f-local>
                                <upload-paper-f-query v-if="paper_upload_state == 'query'"></upload-paper-f-query>
                                <upload-paper-f-dio v-if="paper_upload_state == 'dio'"></upload-paper-f-dio>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */

import addPaperFromDio from './add-paper-from-dio';
import addPaperFromLocal from './add-paper-from-local';
import addPaperFromQuery from './add-paper-from-query';
import { bus } from '@/main';

export default {
    name: 'add-paperfiles',
    components: {
        'upload-paper-f-local': addPaperFromLocal,
        'upload-paper-f-query': addPaperFromQuery,
        'upload-paper-f-dio': addPaperFromDio
    },
    props: [],
    data() {
        return {
            paper_upload_state: 'local'
        }
    },
    computed: {

    },
    mounted() {
    },
    methods: {
        closeCreatePaperpilePopup() {
            bus.$emit('addPaperPilePopupStateBus', false);
            document.body.classList.remove('body_right_scroll_remove')
        },
    }
}
</script>

<style lang="scss" scoped>
.paperpile_section_wrp {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    height: 100%;

    a {
        text-decoration: none;
    }

    &>.row {
        min-height: calc(100dvh - 80px);
    }

    .paperpile_content_header {
        padding: 0px 15px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        margin: 0 -15px;

        .rfiles_main_heading {
            color: #ffffff;
            font-size: 24px;
            text-transform: uppercase;
            font-weight: bold;
            margin: 0px;
        }

        .rfiles_header_right_side {
            list-style: none;
            display: flex;
            align-items: center;
            gap: 15px;
            margin: 0;

            .rfiles_searchbar {
                position: relative;

                i {
                    position: absolute;
                    top: 50%;
                    left: 10px;
                    transform: translateY(-50%);
                    color: #777;
                }

                input {
                    padding-left: 35px;
                    background: #1a1a1a;
                    border: 1px solid #333;
                    border-radius: 4px;
                    color: #fff;

                    &::placeholder {
                        color: #777;
                    }

                    &:focus {
                        border-color: #ffd700;
                        outline: none;
                    }
                }
            }
        }
    }

    .paperpile_content_wrp {
        background: rgba(9, 9, 9, 0.95);
        -webkit-box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        border-radius: 5px;
        padding: 15px;
        height: 100%;

        @media only screen and (max-width:769px) {
            min-height: calc(100dvh - 90px);
        }
    }

    .create_paperpile_popup {
        width: 100%;
        height: 100%;
        color: #ffffff;
        padding: 0 15px;

        .create_paperpile_popup_center {
            display: flex;
            // align-items: center;
            // justify-content: center;
            // min-height: 100vh;
            padding-top: 30px;
        }

        .create_paperpile_popup_modal {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
            max-width: 100%;
            width: 100%;
            border-radius: 8px;
            // border: 1px solid rgba(255, 213, 0, 0.3);
            // box-shadow: 0px 0px 25px rgba(255, 213, 0, 0.2);
            overflow: hidden;
        }

        .paper_tabs {
            display: flex;
            background: #111;
            border-bottom: 1px solid #333;

            .tab_item {
                flex: 1;
                padding: 15px 10px;
                text-align: center;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 5px;
                color: #ffffff;
                transition: all 0.3s ease;
                border-right: 1px solid #222;

                i {
                    font-size: 28px;
                }

                span {
                    font-size: 22px;
                    margin-top: 5px;
                    text-transform: capitalize;
                }

                &:hover {
                    background: #1a1a1a;
                    color: #fff;
                }

                &.active {
                    background: linear-gradient(to bottom, #87cefa, #8bb7ff);
                    color: #000000;
                    border-bottom: 1px solid #000000;
                }
                &:last-child{border-right: 0px;}
            }
        }

        .create_paperpile_popup_body {
            padding: 0;

            .tab_content {
                padding: 30px 20px;
            }
        }
    }
}
</style>